import { useState } from "react";
import { FiEdit, FiPlus } from "react-icons/fi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { RiDeleteBinLine } from "react-icons/ri";
import {  deleteProductHowto, updateProductHowto} from "../../../../api/products";
import CreateHowto from "./CreateHowto";

export default function ProductHowtos({ product, productId, editable }: any) {
  const [createModal, setCreateModal] = useState<boolean>(false);
  const queryClient = useQueryClient();

  const { mutate: updateHowto } = useMutation({
    mutationFn: updateProductHowto,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["products", productId] });
    },
  });


  const { mutate: deleteHowto } = useMutation({
    mutationFn: deleteProductHowto,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Deleted Successfully");
      queryClient.invalidateQueries({ queryKey: ["products", productId] });
    },
  });

  const onUpdate = async ({ id, title, description }: any) => {
    const data = { title, description };
    await updateHowto({ howto_id: id, data });
  };

  const onDelete = async ({ id }: any) => {
    await deleteHowto({ howto_id: id });
  };

  return (
    <div className="">
      <div className="flex justify-between items-center border-b bg-gray-100 p-2">
        <div className="">Product Howtos</div>
        {editable && (
          <button onClick={() => setCreateModal(true)} className="">
            <FiPlus />
          </button>
        )}
      </div>

      <div className="grid grid-cols-12">
        {product?.howtos?.map((howto: any, index: number) => (
          <Howto
            id={howto?.id}
            title={howto?.title}
            description={howto?.description}
            onUpdate={onUpdate}
            onDelete={onDelete}
            index={index}
          />
        ))}
      </div>
      <CreateHowto
        isVisible={createModal}
        setVisible={setCreateModal}
        product={product}
        productId={productId}
      />
    </div>
  );
}

function Howto({ id, title, description, onUpdate, onDelete, index }: any) {
  return (
    <button
      className={` relative col-span-12 border flex flex-col justify-center items-start m-1 p-2`}
      key={index}
    >
      <button
        className="absolute top-0 right-0 z-50 bg-gray-100 w-6 h-6 flex items-center justify-center border-b border-l border-gray-200 hover:bg-red-200 hover:color-red-500"
        onClick={() => onDelete({id})}
      >
        <RiDeleteBinLine color="gray" />
      </button>
      <button
        className="absolute top-0 right-6 z-50 bg-gray-100 w-6 h-6 flex items-center justify-center border-b border-l border-gray-200 hover:bg-yellow-200 hover:color-yellow-500"
        onClick={() => onUpdate({ id, title, description })}
      >
        <FiEdit color="gray" />
      </button>
      <div
        className="flex flex-col items-start"
        
      >
        <div className="font-bold">Step {index + 1} :{title}  </div>
       <div className="text-justify">{description}</div>
      </div>
    </button>
  );
}
